// extracted by mini-css-extract-plugin
export default {"header":"StakeholderAttributesPage_header__X040a","pageTitle":"StakeholderAttributesPage_pageTitle__y8PLh","formWrapper":"StakeholderAttributesPage_formWrapper__35X+B"};